<template lang="pug">
div
  modal(:name="modalName" :adaptive="true" width="600px"  height="auto" :clickToClose="false").walleto-kyc-reset-warning-modal
    .walleto-kyc-reset-warning-modal__container
      h2 {{$t('kycresetmodal.title') }}
      div.walleto-kyc-reset-warning-modal__text
        p {{$t('kycresetmodal.line1') }}
        p {{$t('kycresetmodal.line2') }}
        p {{$t('kycresetmodal.line3') }}
      br
      div.walleto-kyc-reset-warning-modal__buttons
        button(type="button" @click.prevent="clickCancel" :disabled="isDisabled").btn.btn-default {{$t('Напомнить позже')}}
        button(type="button" @click.prevent="clickMakeFreeKyc" :disabled="isDisabled").btn.btn-success
          template(v-if="!isMakingStatus") {{$t('kycresetmodal.submit')}}
          template(v-if="isMakingStatus")
            circle-loader(size="12px") {{$t('kycresetmodal.submit')}}
      div(v-if="isMakingRedirection && showRedirectionHint").redirect-hint
        i18n(tag="p" path="kycresetmodal.hint")
          template(v-slot:link)
            a(:href="redirectUrl" target="_blank" @click="closeAfterTimeout")
              strong {{$t('ссылке')}}
      div(v-if="showError").error-hint
        i18n(tag="p" path="kycresetmodal.error")
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {WalletoResetKycModel} from "@/views/pages/global/notices/walleto-kyc-modal";
import {RemoteRequestState} from "@/backoffice/components/pages/taxrules/taxrules";
import CircleLoader from "@/components/loaders/CircleLoader.vue";

@Component({
  name: "WalletoKycResetWarningModal",
  components: {
    CircleLoader
  }
})
export default class WalletoKycResetWarningModal extends Vue{
  @Prop({default: true})
  autoShow: boolean

  id = Math.random() + (new Date()).toDateString();
  model = new WalletoResetKycModel();

  makingStatus = new RemoteRequestState();
  redirectStatus: RemoteRequestState = new RemoteRequestState();
  redirectUrl = ''
  showRedirectionHint = false
  showError = false
  errorTimeout = null

  get isDisabled() {
    return this.makingStatus.isLoading || this.redirectStatus.isLoading;
  }

  get isMakingStatus() {
    return this.makingStatus.isLoading;
  }

  get modalName() {
    return 'walletoKycResetWarning-' + this.id
  }

  tryAndOpenModal() {
    return this.model.checkWalletoProfile().then((result) => {
      this.$nextTick(() => {
        this.updateModal();
      })
      return result;
    });
  }

  mounted() {
    if (this.autoShow && !this.model.checkCancel())
    {
      this.model.checkWalletoProfile().then((result) => {
        this.$nextTick(() => {
          this.updateModal();
        })
      });
    }

  }

  closeAfterTimeout() {
    setTimeout(() => {
      this.$modal.hide(this.modalName);
      this.redirectUrl = '';
    }, 1000);
  }

  toShowError() {
    if (this.errorTimeout)
      clearTimeout(this.errorTimeout);
    this.errorTimeout = setTimeout(() => {
      this.showError = false;
    }, 5000);
    this.showError = true;
  }

  toHideError() {
    if (this.errorTimeout)
      clearTimeout(this.errorTimeout);
    this.showError = false;
  }

  clickCancel() {
    this.toHideError();
    this.$modal.hide(this.modalName);
    this.model.rememberCancelForAwhile();
    this.$emit('modal-canceled');
  }

  get isMakingRedirection() {
    return this.redirectStatus.isLoading;
  }

  forceRedirect() {
    if (this.redirectUrl.length > 0)
    {
      this.$modal.show(this.modalName);
      this.redirectStatus.loadStart();
      this.model.rememberCancelForAwhile();
      window.open(this.redirectUrl);
      setTimeout(() => {
        this.redirectStatus.loadEnd();
      }, 5000);
      setTimeout(() => {
        this.showRedirectionHint = true;
      }, 1000);
    }
  }

  clickMakeFreeKyc() {
    this.toHideError();
    this.makingStatus.loadStart();
    this.redirectUrl = '';
    this.showRedirectionHint = false;
    this.model.makeFreeKyc().then((redirectUrl) => {
      this.redirectUrl = redirectUrl;
      this.$emit('kyc-redirect', redirectUrl);
      this.forceRedirect();
      this.makingStatus.loadEnd();
    }).catch((err) => {
      this.toShowError();
      this.makingStatus.loadEnd();
      this.redirectStatus.loadEnd();
      throw err;
    });
  }

  updateModal() {
    if (this.model.hasKycData && this.model.isRejected)
    {
      this.$modal.show(this.modalName);
      this.$emit('modal-opened');
    }
  }
}
</script>

<style scoped lang="less">
.walleto-kyc-reset-warning-modal {
  .redirect-hint {
    font-size: 90%;
    margin-top: 40px;
    background: #fffaa4;
    padding: 20px;
    border-radius: 5px;
    p {
      margin: 0;
    }
    a {
      text-decoration: underline;
    }
  }

  .error-hint {
    font-size: 90%;
    margin-top: 40px;
    background: #ffd4d4;
    padding: 20px;
    border-radius: 5px;
    p {
      margin: 0;
    }
    a {
      text-decoration: underline;
    }
  }

  .walleto-kyc-reset-warning-modal__buttons {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    justify-items: center;
    grid-gap: 15px;
  }
  .walleto-kyc-reset-warning-modal__container {
    padding: 40px 40px 40px 40px;
    h2 {
      font-size: 24px;
      font-weight: bolder;
      padding-left: 0;
      margin-bottom: 0;
      margin-top: 0;
      &:before {
        display: none;
      }
    }
    .walleto-kyc-reset-warning-modal__text {
      margin-top: 2em;
      line-height: 1.4em;
      p {
        padding: 0.4em 0;
        margin: 0;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "kycresetmodal": {
      "title": "Изменения в правилах идентификации (KYC)",
      "line1": "Для граждан вашей страны изменились правила идентификации (KYC).",
      "line2": "Для пополнения и выпуска карт Capitalist вам необходимо пройти идентификацию (KYC) заново.",
      "line3": "Повторная идентификация бесплатна.",
      "submit": "Пройти заново",
      "hint": "Если окно для прохождения идентификации не открылось автоматически, пройдите по {link}.",
      "error": "Не удается получить ссылку на прохождение повторной идентификации (KYC). Попробуйте снова или обратитесь в Службу Поддержки."
    }
  },
  "en": {
    "ссылке": "link",
    "Напомнить позже": "Remind me later",
    "kycresetmodal": {
      "title": "Changes to the identification rules (KYC)",
      "line1": "Identification rules (KYC) have changed for citizens of your country.",
      "line2": "To be able to replenish or issue Capitalist cards, you have to go through the KYC identification again.",
      "line3": "Re-identification is free of charge.",
      "submit": "Go to identification (KYC)",
      "hint": "If the identification window did not open automatically, follow the {link}.",
      "error": "Error occured while generating KYC re-identification URL. Please try again or contact Support service."
    }
  }
}
</i18n>
